import { render, staticRenderFns } from "./ForeignContractors.vue?vue&type=template&id=622c31bf&scoped=true&"
import script from "./ForeignContractors.vue?vue&type=script&lang=ts&"
export * from "./ForeignContractors.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622c31bf",
  null
  
)

export default component.exports